module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Mic-b1118ce1cb947b8838eca8273fa7cd5d.svg";